module.exports = __webpack_public_path__ + "media/nl_nl_s3_Lotte.3f406bbc.mp3";